import { StarFilled } from '@ant-design/icons';
import { Space, Tooltip } from 'antd';
import type { ReactNode } from 'react';
import { CardTitleLargeSpan } from '../components/formSpans';

export type CaptureUploadHeaderProps = {
  title: string;
  betaLabel: string;
  betaTooltip: string;
  actions?: ReactNode;
  starIcon?: ReactNode;
  betaStarIcon?: ReactNode;
};

export const CaptureUploadHeader = ({
  title,
  betaLabel,
  betaTooltip,
  actions,
  starIcon,
  betaStarIcon,
}: CaptureUploadHeaderProps) => (
  <div className="capture-upload-header">
    <CardTitleLargeSpan>
      <Space align="start" size={8}>
        {starIcon ?? <StarFilled className="capture-upload-header-star" />}
        {title}
        <Tooltip title={betaTooltip}>
          <span className="capture-upload-beta">
            {betaStarIcon ?? <StarFilled className="capture-upload-beta-star" />}
            {betaLabel}
          </span>
        </Tooltip>
      </Space>
    </CardTitleLargeSpan>
    {actions ? (
      <div className="capture-upload-header-actions">{actions}</div>
    ) : null}
  </div>
);
